// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const $ = require('jquery');
const React = require('react');
const ReactDOM = require('@trello/react-dom-wrapper');
const _ = require('underscore');

class ReactWrapper extends React.Component {
  static initClass() {
    this.prototype.displayName = 'Wrapper';
  }

  UNSAFE_componentWillMount() {
    // Trigger a data load
    return typeof this.props.view.getData === 'function'
      ? this.props.view.getData()
      : undefined;
  }

  componentDidMount() {
    const node = ReactDOM.findDOMNode(this);

    const { el } = this.props.view.render();

    return $(node).append(el);
  }

  render() {
    let passedProps;
    if (this.props.onClick) {
      passedProps = _.assign(_.pick(this.props, ['className']), {
        onClick: this.props.onClick,
      });
    } else {
      passedProps = _.pick(this.props, ['className']);
    }

    return React.createElement('div', passedProps);
  }
}

ReactWrapper.initClass();
module.exports = ReactWrapper;
